import { CouponType, CouponValue } from "../types/coupon";

  // 차량 타입 옵션
  export const vehicleOptions = [
    { value: 'S', label: '킥보드' },
    { value: 'B', label: '자전거' },
    { value: 'M', label: '모패드' },
    { value: 'SB', label: '킥보드, 자전거' },
    { value: 'SM', label: '킥보드, 모패드' },
    { value: 'BM', label: '자전거, 모패드' },
    { value: 'SBM', label: '킥보드, 자전거, 모패드' },
  ];

  // 쿠폰 옵션
  export const normalCouponOptions = [
    { value: '0', label: '5분 무료이용 쿠폰' },
    { value: '1', label: '10분 무료이용 쿠폰' },
    { value: '2', label: '5분 보상 쿠폰' },
    { value: '3', label: '10분 보상 쿠폰' },
    { value: '4', label: '잠금 해제 쿠폰' },
    { value: '7', label: '대학생 쿠폰' },
  ];

  export const partnerCouponOptions = [
    { value: '5', label: '대리기사님 쿠폰' },
    { value: '6', label: '가맹점(프렌차이즈)쿠폰' },
    { value: '9', label: '옐로우버스 파트너 쿠폰' },
  ];


// 쿠폰 설정 상수
export const COUPON_CONFIGS: Record<Exclude<CouponType, ''>, Omit<CouponValue, 'issuer' | 'expiryDate' | 'couponVehicleSType'>> = {
  '0': {
    description: "무료 이용 쿠폰",
    discountTime: "5",
    type: "user",
    couponNumber: "CX_SWING_05MIN"
  },
  '1': {
    description: "무료 이용 쿠폰",
    discountTime: "10",
    type: "user",
    couponNumber: "CX_SWING_10MIN"
  },
  '2': {
    description: "보상 쿠폰",
    discountTime: "5",
    type: "user",
    couponNumber: "CX_SWING_05MIN_REWARD"
  },
  '3': {
    description: "보상 쿠폰",
    discountTime: "10",
    type: "user",
    couponNumber: "CX_SWING_10MIN_REWARD"
  },
  '4': {
    description: "잠금 해제 쿠폰",
    discountUnlockRatio: "1",
    type: "user",
    couponNumber: "CX_SWING_UNLOCK"
  },
  '5': {
    description: "대리기사님X스윙",
    discountUnlockRatio: "1",
    type: "driver",
    couponNumber: "PARTNER_CHAUFFEUR"
  },
  '6': {
    description: "더스윙 가맹점",
    discountRatio: "1",
    type: "franchise",
    couponNumber: "PARTNER_FREE"
  },
  '7': {
    description: "대학생이라면 누구나 쿠폰",
    discountRatio: "0.4",
    type: "univ",
    couponNumber: "EVENT_2209_STUDENT_UNIV"
  },
  '8': {
    description: "대학생이라면 누구나 쿠폰",
    discountRatio: "0.4",
    type: "univ",
    couponNumber: "EVENT_2209_STUDENT_UNIV"
  },
  '9': {
    description: "YB 관리자 쿠폰",
    discountRatio: "1",
    type: "franchise",
    couponNumber: "PARTNER_YB_FREE"
  }
};

// 만료일/개수 자동 설정이 필요한 쿠폰 타입들
export const AUTO_SET_COUPONS: CouponType[] = ['5', '6', '7'];

// 개수 자동 설정이 필요한 쿠폰
export const AUTO_SET_COUNT_COUPONS: CouponType[] = ['9'];